require('./InventoryAndTransfersModal.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  Notification = require('components/Notification/Notification'),
  {delay} = require('lodash/function'),
  ContentUtils = require('utils/ContentUtils'),
  SessionStore = require('stores/SessionStore'),
  ComponentUtils = require('utils/ComponentUtils'),
  LocationStore = require('stores/LocationStore'),
  DropDown = require('components/Commons/DropDown/DropDown'),
  NumberUtils = require('utils/NumberUtils'),
  {FlatButton, SelectField, TextField} = require('material-ui'),
  get = require('lodash/object').get,
  CustomModal = require('components/Commons/CustomModal/CustomModal'),
  {findIndex} = require('lodash/array'),
  {filter, find, map, reduce} = require('lodash/collection'),
  {PropTypes} = require('react');


const AMOUNT_DECIMALS = 4;

const InventoryAndTransfersModal = React.createClass({displayName: "InventoryAndTransfersModal",

    propTypes: {
      items: PropTypes.array,
      locationItems: PropTypes.array,
      locations: PropTypes.array,
      onClose: PropTypes.function
    },

    _inputAmountToTransfer: null,

    getInitialState() {
      return {
        locationsToIndex: 1,
        isVisible: false,
        title: t('inventory_and_transfer_modal_title'),
        locationsFromMessageError: '',
        locationsToMessageError: '',
        locationsAmountMessageError: '',
        itemMessageError: ''
      };
    },

    componentWillUnmount() {
      clearTimeout(this.timeout);
    },

    focusAmount() {
      const self = this;
      if (this._inputAmountToTransfer) {
        delay(() => {
          self._inputAmountToTransfer.getDOMNode().querySelector('input').focus();
        }, 500); // give time to finish open dialog transition
      }
    },

    _onSaveAndClose() {
      const {locationItems} = this.props;
      const {selectedLocationItemFrom, selectedLocationItemTo} = this.state;
      const {amountToTransfer} = this.state;

      const amountToTransferStandarized = NumberUtils.standardiseDecimalFormatNumber(amountToTransfer);
      const amountOrigin = NumberUtils.getNumberString(get(selectedLocationItemFrom, 'amount'));
      const messageError = LocationStore.isValidTransfer(amountOrigin, this.state.estimatedOrigin, amountToTransferStandarized);
      const isValidTransfer = messageError === '';
      const self = this;

      if (isValidTransfer) {
        // locations identifiers
        const locationToId = get(selectedLocationItemTo, 'locationId') || get(selectedLocationItemTo, 'location.id') || get(selectedLocationItemTo, 'id');
        const locationFromId = get(selectedLocationItemFrom, 'locationId') || get(selectedLocationItemFrom, 'location.id');
        const itemId = get(selectedLocationItemFrom, 'itemId');

        // the amounts of origin and destination without apply the transfer yet
        const locationItemTo = find(locationItems, locationItem => get(locationItem, 'locationId') === locationToId && get(locationItem, 'itemId') === itemId);
        const locationToAmount = get(locationItemTo, 'amount');

        // the amounts of items already updated & transfer info
        const transferInfo = LocationStore.transfer(amountOrigin, locationToAmount, amountToTransferStandarized);
        transferInfo.locationFromId = locationFromId;
        transferInfo.locationToId = locationToId;
        transferInfo.itemId = itemId;

        LocationStore.saveTransfer(transferInfo, () => {
          Notification.show(t('inventory_and_transfer_modal_transfer_success'), 'success');
          self.close();
        }, () => {
          Notification.show(t('dashboard_notification_something_was_wrong'));
        });

      } else {
        this.setState({
          locationsAmountMessageError: messageError
        });
      }
    },

    show(selectedLocationItemFrom) {
      const {locations} = this.props;

      const enableLocations = ContentUtils.filterEnable(locations);

      // Select location destination
      const selectedLocationId = get(selectedLocationItemFrom, 'locationId', '') || get(selectedLocationItemFrom, 'location.id');
      const locationsWithoutFrom = filter(enableLocations, location => get(location, 'id') !== selectedLocationId) || [];
      const selectedLocationItemTo = get(locationsWithoutFrom, '0'); // just pick the first one
      const locationsToIndex = 1; // always the first one

      const initialState = {
        locationsWithoutFrom,
        locationsToIndex,
        selectedLocationItemFrom,
        selectedLocationItemTo,
        selectedLocationToId: get(selectedLocationItemTo, 'id'),
        estimatedOrigin: null,
        estimatedDestination: null,
        amountToTransfer: 0, // initial,
        isVisible: true
      };

      this.setState(initialState, () => {
        this.focusAmount();
      });
    },

    close() {
      const self = this;
      this.setState(this.getInitialState(), () => {
        self.props.onClose();
      });
    },

    _onChangeLocationTo(locationToSelected) {
      this._inputAmountToTransfer.setValue('');

      const itemId = get(this.state, 'selectedLocationItemFrom.itemId');
      const itemUnit = get(this.state, 'selectedLocationItemFrom.unit');
      const locationId = get(locationToSelected, 'itemModel.id');
      let selectedLocationItemTo = find(this.props.locationItems, locationItem => get(locationItem, 'itemId') === itemId && get(locationItem, 'locationId') === locationId);
      if (!selectedLocationItemTo) {
        const emptyState = {
          itemId,
          itemUnit,
          locationId,
          locationName: locationToSelected.text,
          applicantId: SessionStore.getCurrentApplicantId(),
          locationsItems: this.props.locationItems
        };
        selectedLocationItemTo = getEmptyLocationItemTo(emptyState);
      }
      this.setState(prevState => {
        return {
          locationsToIndex: get(locationToSelected, 'payload'),
          selectedLocationItemTo,
          estimatedDestination: null, // reset destination in order to re-calculate total destination again
          amountToTransfer: null,
          estimatedOrigin: get(prevState, 'selectedLocationItemFrom.amount'), // reset to origin amount
          // reset message error
          locationToId: locationId,
          locationsFromMessageError: '',
          locationsToMessageError: '',
          locationsAmountMessageError: '',
          itemMessageError: ''
        };
      });
    },

    _onChangeAmount(evt) {
      const amountToTransfer = NumberUtils.standardiseDecimalFormatNumber(NumberUtils.getNumberString(get(evt, 'target.value')));

      const {selectedLocationItemFrom, selectedLocationItemTo} = this.state;

      this.setState(prevState => {
        // amount origin
        const amountOriginPristine = get(selectedLocationItemFrom, 'amount');

        // amount destination
        const amountDestinationPristine = get(selectedLocationItemTo, 'amount');

        const messageError = LocationStore.isValidTransfer(amountOriginPristine, this.state.estimatedOrigin, amountToTransfer);
        const isValidTransfer = messageError === '';

        if (isValidTransfer) {
          // make transfer
          const estimatedTransferInfo = LocationStore.transfer(amountOriginPristine, amountDestinationPristine, amountToTransfer);
          const estimatedOrigin = get(estimatedTransferInfo, 'locationItemAmountFrom');
          const estimatedDestination = get(estimatedTransferInfo, 'locationItemAmountTo');

          return {
            amountToTransfer,
            estimatedOrigin,
            estimatedDestination,
            // reset message error
            locationsFromMessageError: '',
            locationsToMessageError: '',
            locationsAmountMessageError: '',
            itemMessageError: ''
          };
        } else {
          return {
            locationsAmountMessageError: messageError
          };
        }
      });
    },

    _onChangeItem(evt, index, itemSelected) {
      this.setState({
        itemsIndex: get(itemSelected, 'payload')
      });
    },

    _getContentEl() {
      const {locations, locationItems} = this.props;
      const enableLocations = ContentUtils.filterEnable(locations);
      const {estimatedOrigin, estimatedDestination, selectedLocationItemFrom, selectedLocationItemTo, locationsWithoutFrom} = this.state;
      const itemMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(locationItems, t('inventory_and_transfer_select_items_placeholder'), t('description'));

      // From information
      const selectedItemId = get(selectedLocationItemFrom, 'itemId', '');
      const selectedLocationId = get(selectedLocationItemFrom, 'locationId', '');
      const unit = get(selectedLocationItemFrom, 'unit', '');
      const unitWithParenthesis = unit ? ' (' + unit + ')' : unit;
      const locationIndexFrom = findIndex(enableLocations, location => get(location, 'id') === selectedLocationId) + 1;
      const itemIndexFrom = findIndex(locationItems, locationItem => get(locationItem, 'itemId') === selectedItemId) + 1;
      const locationItemFrom = (estimatedOrigin || estimatedOrigin === 0) ? NumberUtils.formatDecimal(estimatedOrigin, AMOUNT_DECIMALS) : NumberUtils.formatDecimal(get(selectedLocationItemFrom, 'amount'), AMOUNT_DECIMALS);
      const locationMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableLocations, t('inventory_and_transfer_select_location_placeholder'));

      // To information
      const locationItemToAmount = get(selectedLocationItemTo, 'amount');

      return (
        React.createElement("div", {className: "bp-location-transfer-modal"}, 
          React.createElement("div", {className: "bp-location-transfer-modal__header"}, 
            React.createElement("h4", {className: "bp-location-transfer-modal__header-title"}, t('inventory_and_transfer_modal_from_label')), 
            React.createElement("hr", null), 
            React.createElement("div", {className: "bp-location-transfer-modal__fields"}, 
              React.createElement(SelectField, {
                id: "", 
                className: "bp-location-transfer-modal__select-from", 
                floatingLabelText: t('inventory_and_transfer_modal_from_label'), 
                menuItems: locationMenuItems, 
                errorText: this.state.locationsFromMessageError, 
                value: locationIndexFrom, 
                disabled: true
              }
              ), 
              React.createElement(SelectField, {
                floatingLabelText: `${t('inventory_and_transfer_items')}${unitWithParenthesis}`, 
                menuItems: itemMenuItems, 
                errorText: this.state.itemMessageError, 
                value: itemIndexFrom, 
                disabled: true
              }
              ), 
              React.createElement(TextField, {
                className: "bp-location-transfer-modal__input", 
                value: locationItemFrom, 
                floatingLabelText: `${t('inventory_and_transfer_modal_amount_in_locations')} ${unitWithParenthesis}`, 
                onEnterKeyDown: this._onSaveAndClose, 
                onBlur: this._onChangeAmount, 
                disabled: true}
              )
            )
          ), 
          React.createElement("div", {className: "bp-location-transfer-modal__body"}, 
            React.createElement("h4", {className: "bp-location-transfer-modal__body-title"}, t('inventory_and_transfer_modal_to_label')), 
            React.createElement("hr", null), 
            React.createElement("div", {className: "bp-location-transfer-modal__fields"}, 
              React.createElement(DropDown, {
                className: "bp-location-transfer-modal__select-to", 
                floatingLabelText: t('inventory_and_transfer_modal_to_label'), 
                onChange: this._onChangeLocationTo, 
                items: locationsWithoutFrom, 
                readerAttribute: "name", 
                name: t('inventory_and_transfer_location'), 
                errorText: this.state.locationsToMessageError, 
                selectedIndex: this.state.locationsToIndex}
              ), 
              React.createElement(TextField, {
                ref: input => this._inputAmountToTransfer = input, 
                className: "bp-location-transfer-modal__input", 
                hintText: t('inventory_and_transfer_modal_enter_amount'), 
                floatingLabelText: `${t('inventory_and_transfer_amount')} ${unitWithParenthesis}`, 
                onEnterKeyDown: this._onSaveAndClose, 
                onBlur: this._onChangeAmount, 
                errorText: this.state.locationsAmountMessageError}
              ), 
              React.createElement(TextField, {
                className: "bp-location-transfer-modal__input", 
                value: NumberUtils.formatDecimal(estimatedDestination ? estimatedDestination : locationItemToAmount, AMOUNT_DECIMALS), 
                floatingLabelText: `${t('inventory_and_transfer_modal_amount_in_locations')} ${unitWithParenthesis}`, 
                onEnterKeyDown: this._onSaveAndClose, 
                onBlur: this._onChangeAmount, 
                disabled: true}
              )
            )
          )
        )
      );
    },

    _getActionsModal() {
      return [
        React.createElement(FlatButton, {
          label: t('inventory_and_transfer_modal_cancel'), 
          onTouchTap: this.close
        }
        ),
        React.createElement(FlatButton, {
          label: t('inventory_and_transfer_modal_save'), 
          onTouchTap: this._onSaveAndClose, 
          primary: true
        }
        )
      ];
    },

    render() {
      const {selectedModule} = this.props;
      const {selectedLocationItemFrom} = this.state;

      if (!selectedLocationItemFrom) {
        return null;
      }

      const actionsEl = this._getActionsModal(selectedLocationItemFrom);
      const contentEl = this._getContentEl(selectedLocationItemFrom, selectedModule);

      return (
        React.createElement(CustomModal, {
          actions: actionsEl, 
          title: this.state.title, 
          isVisible: this.state.isVisible, 
          customClass: "inventory-transfer-modal modal-transfer"
        }, 
          contentEl
        )
      );
    }
  })
;

function getEmptyLocationItemTo(emptyState) {
  const totalAmount = getTotalItemAmountCrossLocation(locationItems, itemId);
  const {itemId, itemUnit, locationId, locationName, applicantId, locationItems} = emptyState;
  return {
    isEnable: true,
    id: undefined, // because it doesn't exist yet
    name: locationName,
    item: {id: itemId},
    location: {id: locationId},
    applicant: {id: applicantId},
    amount: '0',
    totalAmount,
    totalAmountFormatted: `${NumberUtils.formatDecimal(totalAmount)} ${itemUnit}`
  };
}

function getTotalItemAmountCrossLocation(locationItems, itemId) {
  const locationItemsFiltered = filter(locationItems, locationItem => get(locationItem, 'itemId') === itemId);
  if (ContentUtils.isNotEmptyArray(locationItemsFiltered)) {
    const locationItemsAmount = map(locationItems, locationItem => get(locationItem, 'amount')) || ['0']; // empty state
    return reduce(locationItemsAmount, (total, amount) => NumberUtils.sum(total, amount)) || '0'; // empty state
  }
}

module.exports = InventoryAndTransfersModal;



/** WEBPACK FOOTER **
 ** ./src/views/InventoryAndTransfersAdmin/InventoryAndTransfersModal/InventoryAndTransfersModal.jsx
 **/